<template>
  <vue-scroll>
    <rabbey-toolbox :call-new="callNew" />

    <RabbeyTable3
      :columns="columns"
      :data="items"
      style="margin: 20px"
      :actions="actions"
      @rtable-push-action="handlePushAction"
    />

    <el-drawer
      :title="tituloDrawer"
      :visible="openDetail"
      :size="sizedrawer"
      :before-close="CloseTransactionDetail"
    >
      <el-row :gutter="20" v-if="mostrardetalles">
        <el-col :offset="1">
          <h3>{{ textoEncuesta }}</h3>
          <span>{{ textoPlataforma }}</span>
        </el-col>
        <hr />
      </el-row>

      <!-- <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
      
        <el-form-item label="Activity zone" prop="region">
    <el-select v-model="ruleForm.region" placeholder="Activity zone">
      <el-option label="Zone one" value="shanghai"></el-option>
      <el-option label="Zone two" value="beijing"></el-option>
    </el-select>
  </el-form-item>
        <el-form-item :label="imputpreguntas" prop="titulo">
          <el-input v-model="ruleForm.titulo"></el-input>
        </el-form-item>
        <el-form-item label="Plataforma" prop="Plataforma" >
              <el-select
                v-model="ruleForm.Plataforma"
                placeholder="Selecciona el tipo de Plataforma"
                :disabled="viewselect"
              >
                <el-option
                  v-for="item in listOptionstypePlataforma"
                  :key="item.Idplatform"
                  :label="item.Nameplatform"
                  :value="item.Nameplatform"
                >
                </el-option>
              </el-select>
            </el-form-item>
        <el-button @click="resetForm1('ruleForm')">Reset</el-button>

            <el-button
              type="primary"
              @click="ManageSurvey2('ruleForm')"
              v-if="mostrarbotonSurvey"
              >Guardar</el-button>
      </el-form> -->

      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
        :label-position="posionlabel"
        style="margin-left: 20px"
      >
        <el-row :gutter="20">
          <el-col :span="16"
            ><el-form-item :label="imputpreguntas" prop="titulo">
              <el-input v-model="ruleForm.titulo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-button
              type="primary"
              @click="ManageQuestions('ruleForm')"
              v-if="mostrarbotonquestion"
              >{{ this.BotonManage }}</el-button
            >
            <div class="grid-content bg-purple"></div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="Plataforma" prop="Plataforma">
              <el-select
                v-model="ruleForm.Plataforma"
                placeholder="Selecciona el tipo de Plataforma"
                :disabled="viewselect"
              >
                <el-option
                  v-for="item in listOptionstypePlataforma"
                  :key="item.Idplatform"
                  :label="item.Nameplatform"
                  :value="item.Nameplatform"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item
              label="Frecuencia"
              prop="Frecuencia"
              v-if="frecuencia"
            >
              <el-select
                v-model="ruleForm.Frecuencia"
                placeholder="Selecciona la frecuencia"
                :disabled="viewselect"
              >
                <el-option key="1" label="Inmediato" value="0"> </el-option>
                <el-option key="2" label="Mensual" value="1"> </el-option>
                <el-option key="3" label="Trimestral" value="3"> </el-option>
                <el-option key="4" label="Anual" value="12"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item v-if="mostarRequerido">
              <el-checkbox v-model="checked">Pregunta Requerida</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="Fecha de Inicio" v-if="startedtime">
              <el-date-picker
                type="date"
                placeholder="Fecha de Inicio"
                v-model="ruleForm.startedtime"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Estatus" v-if="mostrarEstatus">
              <el-switch
                v-model="ruleForm.status"
                active-color="#13ce66"
                inactive-color="#ff4949"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <!-- Esto se puede borrar -->
          <!-- <el-col :span="20">
            <h2 style="width: 100%; background-color: black"></h2>
          </el-col> -->
          <el-col :span="20">
            <el-form-item label="Descripccion" v-if="mostrardescipccion">
              <el-input
                type="textarea"
                :rows="5"
                v-model="ruleForm.LabelDescrip"
                width="3000px"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="10">
            <el-form-item
              label="Tipo"
              v-if="mostrarselecttipo"
              prop="tipopregunta"
            >
              <el-select
                v-model="ruleForm.tipopregunta"
                placeholder="Selecciona el tipo de pregunta"
                @change="SelectTypeQuestions"
              >
                <el-option
                  v-for="item in listOptionstypequestion"
                  :key="item.Id"
                  :label="item.DescriptionName"
                  :value="item.Name"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="">
              <el-select
                v-model="formLabelAlign.tipo"
                placeholder="Seleccione Cantidad"
                v-if="mostrarselect"
                @change="Selectcantidad"
              >
                <el-option label="1-5" value="1,2,3,4,5"></el-option>
                <el-option
                  label="1-10"
                  value="1,2,3,4,5,6,7,8,9,10"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :offset="10"> </el-col>

          <el-col :span="6"> </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :offset="17">
            <el-button
              type="primary"
              @click="ManageSurvey('ruleForm')"
              v-if="mostrarbotonSurvey"
              >{{ this.BotonManage }}</el-button
            >
          </el-col>
        </el-row>
      </el-form>
      <el-row style="margin-top: 20px" v-if="mostrarselect">
        <el-form
          :label-position="labelPosition"
          label-width="100px"
          :model="formLabelAlign"
        >
          <el-alert
            title="Las Opciones se deben de separar por (,): Opcion 1,Opcione 2,Opcione 3 "
            type="info"
            center
            show-icon
          >
          </el-alert>
          <el-form-item label="Opciones">
            <el-input v-model="formLabelAlign.tipoopciones"></el-input>
          </el-form-item>
        </el-form>
        <el-col> </el-col>
      </el-row>

      <RabbeyTable3
        :columns="columnsquestions"
        :data="itemsquestions"
        style="margin: 20px"
        :actions="actionsdrawer"
        @rtable-push-action="handlePushActionDrawer"
        @selection-change="handleSelectionChange"
        v-if="mostrartable"
      />
    </el-drawer>
  </vue-scroll>
</template>

<script>
// import { formatDate } from "../../utils";
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import RenderCheckLabelRequired from "@/components/functionals/RenderCheckLabelRequired.vue";
// import RenderCheckLabel from "@/components/functionals/RenderCheckLabel.vue";

export default {
  name: "ContactList",
  components: {
    RabbeyTable3
    // RenderCheckLabel
    // RenderCheckLabelRequired
  },
  data() {
    return {
      ruleForm: {
        titulo: "",
        LabelDescrip: "",
        Plataforma: "",
        tipopregunta: "",
        Frecuencia: "",
        startedtime: "",
        status: true
      },
      rules: {
        titulo: [
          {
            required: true,
            message: "Por favor Ingrese un titulo",
            trigger: "blur"
          }
        ],
        Plataforma: [
          {
            required: true,
            message: "Por favor Seleccione una plataforma.",
            trigger: "change"
          }
        ],
        tipopregunta: [
          {
            required: true,
            message: "Por favor Seleccione un tipo de pregunta.",
            trigger: "blur"
          }
        ]
      },

      items: [],
      mostrarselect: false,
      title: "Crear Formulario",
      drawer: false,
      isView: false,
      startedtime: false,
      // isEdit: false,
      value1: true,
      mostrardetalles: true,
      // mostrartable: false,
      sizedrawer: "30%",
      No_FormReal: 0,
      textoEncuesta: "",
      textoPlataforma: "",
      mostrarTag: false,
      BotonManage: "Crear",
      // viewselect:"inline-block",
      frecuencia: false,
      viewselect: false,
      mostrarbotonSurvey: false,
      mostarRequerido: true,
      mostrarEstatus: true,
      mostrartable: true,
      mostrarbotonquestion: false,
      checked: true,
      typebuttom: "el-icon-check",
      tituloDrawer: "Gestion de Preguntas ",
      openDetail: false,
      typerequest: 1,
      questionId: 0,
      No_Form: 0,
      mostrardescipccion: false,
      labelPosition: "right",
      mostrarselecttipo: true,
      imputpreguntas: "",
      itemsquestions: [],
      DescripccionEncuesta: "",
      listOptionstypequestion: [],
      listOptionstypePlataforma: [],
      formLabelAlign: {
        LabelQuestion: "",
        region: "",
        type: "",
        tipo: "",
        tipopregunta: "",
        tipoopciones: "",
        LabelDescrip: "",
        Plataforma: ""
      },
      // actions: [
      //   {
      //     icon: "el-icon-view",
      //     label: "Ver",
      //     command: "view"
      //   }
      // ],
      columns: [
        {
          prop: "No_FormReal",
          label: "No. Formulario",
          fixed: true,
          minWidth: 100
        },
        {
          prop: "Nombre",
          label: "Nombre",
          minWidth: 100
        },
        {
          prop: "Descripcion",
          label: "Descripcion de Formulario",
          minWidth: 150
        },
        {
          prop: "TypeForm",
          label: "Plataforma",
          width: 100
        },
        {
          prop: "Frecuencia",
          label: "Tipo de Freguencia",
          width: 150
        },
        {
          prop: "IsEnable",
          label: "Estatus",
          width: 100,
          formatter: RenderCheckLabelRequired
        }
      ],
      actions: [
        {
          icon: "el-icon-plus",
          label: "Gestionar Preguntas",
          command: "create"
        },

        {
          icon: "el-icon-edit",
          label: "Editar",
          command: "edit"
        },
        {
          icon: "el-icon-edit",
          label: "Cambiar Estatus",
          command: "status"
        },
        {
          label: "Eliminar",
          icon: "el-icon-delete",
          command: "delete"
        }
      ],
      actionsdrawer: [
        {
          icon: "el-icon-edit",
          label: "Editar",
          command: "edit"
        },
        {
          icon: "el-icon-delete",
          label: "Eliminar",
          command: "delete"
        }
      ],
      columnsquestions: [
        {
          prop: "No_Questions",
          label: "No. Pregunta",
          fixed: true,
          minWidth: 100
        },
        {
          prop: "label",
          label: "Pregunta",
          fixed: true,
          minWidth: 100
        },
        {
          prop: "platform",
          label: "Plataforma",
          fixed: true,
          minWidth: 100
        },
        {
          prop: "VALUE",
          label: "Valores",
          fixed: true,
          minWidth: 100
        },
        {
          prop: "type",
          label: "Tipo de Pregunta",
          fixed: true,
          minWidth: 100
        },
        {
          prop: "Required",
          label: "Requeriod",
          formatter: RenderCheckLabelRequired,

          fixed: true,
          minWidth: 100
        }
      ],
      ParamsManageQuestion: {
        typerequest: 1,
        questionId: 0,
        question: "adadads",
        values: "adsfas",
        platform: "adsfasd",
        Required: true,
        type: "asdfas"
      }
    };
  },
  computed: {
    params() {
      return {
        companyId: this.currentCompany
      };
    }
  },
  created() {
    this.getForms();
    this.getquestionsForms();
    this.getquestionstypes();
    this.getplatafromas();
  },
  methods: {
    resetForm1(formName) {
      this.$refs[formName].resetFields();
    },
    resetForm() {
      this.ruleForm.titulo = "";
      this.ruleForm.tipopregunta = "";
      // this.ruleForm.Plataforma = '';
      this.ruleForm.LabelDescrip = "";
      this.formLabelAlign.tipo = "";
      this.formLabelAlign.tipoopciones = "";
      this.formLabelAlign.questionId = 0;
      this.value1 = false;
      this.checked = false;
      this.ruleForm.LabelDescrip = "";
      this.mostrarselect = false;
    },
    CloseTransactionDetail() {
      this.openDetail = false;
      this.resetForm();
    },
    getForms() {
      this.$http.get("/api/survey/GetSurveyForm").then((resp) => {
        this.items = resp.data;
        this.No_FormReal = resp.data[resp.data.length - 1].No_FormReal;
        this.ruleForm.Plataforma = resp.data[resp.data.length - 1].TypeForm;
        this.mostrardetalles = true;
        this.DescripccionEncuesta = resp.data[resp.data.length - 1].Descripcion;
        this.textoEncuesta = resp.data[resp.data.length - 1].Nombre;
        this.textoPlataforma = resp.data[resp.data.length - 1].TypeForm;
      });
    },
    getquestionsForms() {
      this.$http
        .get(`/api/survey/GetQuestionsForm?No_Form=${this.No_FormReal}`)
        .then((resp) => {
          this.mostrardetalles = true;
          this.itemsquestions = resp.data;
        });
    },
    getquestionstypes() {
      this.$http.get("/api/survey/TypeQuestions").then((resp) => {
        this.listOptionstypequestion = resp.data;
      });
    },
    getplatafromas() {
      this.$http.get("/api/survey/GetPlatamor").then((resp) => {
        this.listOptionstypePlataforma = resp.data;
      });
    },
    postquestion() {
      const params = {
        typerequest: this.typerequest,
        questionId: this.questionId,
        question: this.ruleForm.titulo,
        values: this.formLabelAlign.tipoopciones,
        platform: this.ruleForm.Plataforma,
        Required: this.checked,
        type: this.ruleForm.tipopregunta,
        No_Form: this.No_Form,
        Orden: 0,
        No_FormReal: this.No_FormReal
      };
      this.$http.post("/api/survey/ManageQuestions", params).then(() => {
        this.typebuttom = "el-icon-check";

        this.getquestionsForms();
        if (params.typerequest == 2) {
          this.typerequest = 1;
        }
        this.BotonManage = "Crear";
        this.resetForm();
      });
    },
    ManageQuestions(formName) {
      if (formName == "true") {
        this.postquestion();
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postquestion();
        }
      });
    },
    PostSurvey() {
      const params = {
        typerequest: this.typerequest,
        Nombre: this.ruleForm.titulo,
        Descripcion: this.ruleForm.LabelDescrip,
        values: this.formLabelAlign.tipoopciones,
        TypeForm: this.ruleForm.Plataforma,
        No_Form: this.No_Form,
        frecuencia: this.ruleForm.Frecuencia,
        fecha: this.ruleForm.startedtime,
        status: this.ruleForm.status,
        No_FormReal: this.No_FormReal
      };
      this.$http.post("/api/survey/ManageSurvey", params).then((resp) => {
        this.itemsquestions = [];

        this.resetForm();
        if (resp.data == -1) {
          this.$message.info(
            "No pueden haber 2 encuestas activa con la misma frecuencia"
          );
          this.typerequest == 1;
        } else if (resp.data == 1) {
          this.$message.success("Editado correctamente");
          this.typerequest = 1;
        }
        if (params.typerequest == 1) {
          this.$message.success("Agregado correctamente");
          this.sizedrawer = "50%";
          this.mostrarbotonSurvey = false;
          this.mostrarbotonquestion = true;
          (this.viewselect = true),
            (this.mostrartable = true),
            (this.isView = false);
          this.openDetail = true;
          this.imputpreguntas = "Pregunta";
          this.mostrartable = true;
          this.mostrarselecttipo = true;
          this.mostrardescipccion = false;
          this.mostrarEstatus = true;
          this.mostarRequerido = true;
          this.tituloDrawer = "Gestion de Preguntas";
          this.mostrarselect = false;
          this.typerequest = 1;
          this.typebuttom = "el-icon-check";
          this.frecuencia = false;
          this.startedtime = false;
        } else if (params.typerequest == 3) {
          this.$message.success("Eliminado correctamente");
          this.typerequest = 1;
        } else if (params.typerequest == 1) {
          this.$message.success("Editado correctamente");
          this.typerequest = 1;
        }

        this.getForms();
        this.resetForm();
        this.mostrardetalles = false;
      });
    },
    ManageSurvey(formName) {
      console.log(formName);

      if (formName == "true") {
        this.PostSurvey();
      } else {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.PostSurvey();
            this.getquestionsForms();

            this.$refs[formName].resetFields();
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }

      this.getForms();
    },
    // ManageSurvey() {

    //   const params = {
    //     typerequest: this.typerequest,
    //     Nombre: this.formLabelAlign.LabelQuestion,
    //     Descripcion: this.formLabelAlign.LabelDescrip,
    //     values: this.formLabelAlign.tipoopciones,
    //     TypeForm: this.formLabelAlign.Plataforma,
    //     No_Form: this.No_Form
    //   };
    //   this.$http.post("/api/customers/ManageSurvey", params).then(() => {
    //     this.typebuttom = "el-icon-check";
    //     this.resetForm();
    //     if (params.typerequest == 2 || params.typerequest == 3) {
    //       if (params.typerequest == 2) {
    //         this.$message.success("Editado correctamente");
    //       } else if (params.typerequest == 3) {
    //         this.$message.success("Eliminado correctamente");
    //       }
    //       this.typerequest = 1;
    //     } else {
    //       this.sizedrawer = "50%";
    //       this.mostrarbotonSurvey = false;
    //       this.mostrarbotonquestion = true;
    //       (this.viewselect = true),
    //         (this.mostrartable = true),
    //         (this.isEdit = true);
    //       this.isView = false;
    //       this.openDetail = true;
    //       this.imputpreguntas = "Pregunta";
    //       this.mostrartable = true;
    //       this.mostrarselecttipo = true;
    //       this.mostrardescipccion = false;
    //       this.mostrarEstatus = true;
    //       this.mostarRequerido = true;
    //       this.tituloDrawer = "Gestion de Preguntas";
    //       this.mostrarselect = false;
    //       this.typerequest = 1;
    //       this.getForms();
    //     }
    //   });
    // },

    callNew() {
      this.startedtime = true;
      this.BotonManage = "Guardar";
      this.sizedrawer = "30%";
      this.tituloDrawer = "Crear Formulario";
      this.openDetail = true;
      this.mostrarTag = false;
      this.mostrarbotonquestion = false;
      this.isView = false;
      this.viewselect = false;
      this.mostrardetalles = false;
      this.posionlabel = "top";
      // this.isEdit = false;
      this.imputpreguntas = "Titulo";
      this.drawer = true;
      this.mostrartable = false;
      this.mostrarselecttipo = false;
      this.mostrardescipccion = true;
      this.mostrarEstatus = true;
      this.mostarRequerido = false;
      this.mostrarbotonSurvey = true;
      this.frecuencia = true;
    },
    handlePushActionDrawer(command) {
      this.ruleForm.Plataforma = command.row.platform;
      this.formLabelAlign.tipoopciones = command.row.VALUE;
      this.checked = command.row.Required;
      this.ruleForm.tipopregunta = command.row.type;
      this.questionId = command.row.No_Questions;

      if (command.row.type == "label") {
        this.mostrarselect = true;
      } else {
        this.mostrarselect = false;
      }
      switch (command.command) {
        case "view":
          this.isView = true;
          this.openDetail = true;
          break;

        case "edit":
          this.typebuttom = "el-icon-edit";
          this.typerequest = 2;
          this.BotonManage = "Editar";
          this.mostrarEstatus = false;

          this.ruleForm.titulo = command.row.label;
          if (command.row.VALUE != "") {
            this.mostrarselect = true;
          }
          break;

        case "delete":
          this.typerequest = 3;
          this.postquestion();
          // this.ManageQuestions(true);

          break;

        default:
          break;
      }
    },
    SelectTypeQuestions(selectvalue) {
      if (selectvalue == "radio") {
        this.mostrarselect = true;
      } else {
        this.mostrarselect = false;
      }
    },
    Selectcantidad(valueselect) {
      this.formLabelAlign.tipoopciones = valueselect;
    },
    handlePushAction(command) {
      console.log(command.row);
      this.No_Form = command.row.No_Form;
      this.No_FormReal = command.row.No_FormReal;
      this.ruleForm.startedtime = command.row.StartDate;
      this.ruleForm.status = command.row.IsEnable;
      switch (command.command) {
        case "view":
          this.isView = true;
          this.openDetail = true;
          break;

        case "create":
          // .viewSelect=false
          this.textoEncuesta = command.row.Nombre;
          this.textoPlataforma = command.row.TypeForm;
          this.DescripccionEncuesta = command.row.Descripcion;
          this.No_FormReal = command.row.No_FormReal;
          this.resetForm();
          this.getquestionsForms();
          this.sizedrawer = "50%";
          this.mostrarTag = true;
          this.mostrarbotonSurvey = false;
          this.BotonManage = "Crear";
          this.mostrarbotonquestion = true;
          this.ruleForm.Plataforma = command.row.TypeForm;
          (this.viewselect = true),
            (this.mostrartable = true),
            (this.posionlabel = "left");

          // (this.isEdit = true);
          this.startedtime = false;
          this.frecuencia = false;
          this.isView = false;
          this.openDetail = true;
          this.imputpreguntas = "Pregunta";
          this.mostrartable = true;
          this.mostrarselecttipo = true;
          this.mostrardescipccion = false;
          this.mostrarEstatus = false;
          this.mostarRequerido = true;
          this.tituloDrawer = "Gestion de Preguntas";
          this.mostrarselect = false;
          this.typerequest = 1;

          break;

        case "edit":
          this.mostrardetalles = false;
          this.sizedrawer = "30%";

          this.mostrarbotonquestion = false;
          this.mostrarbotonSurvey = true;
          this.tituloDrawer = "Editar Formulario";
          this.openDetail = true;
          this.ruleForm.titulo = command.row.Nombre;
          this.ruleForm.Plataforma = command.row.TypeForm;
          this.ruleForm.LabelDescrip = command.row.Descripcion;
          this.imputpreguntas = "Titulo";
          this.BotonManage = "Editar";
          // this.drawer = true;
          this.mostrartable = false;
          this.mostrarselecttipo = false;
          this.mostrardescipccion = true;
          this.mostrarEstatus = false;
          this.mostarRequerido = false;
          this.mostrarbotonSurvey = true;
          this.typerequest = 2;

          break;
        case "status":
          this.typerequest = 4;
          this.ManageSurvey("true");
          break;

        case "delete":
          this.typerequest = 3;
          this.ManageSurvey("true");
          // this.$confirm("Segura/o que desea eliminar este registro ?")
          //   .then(() => {

          //     this.$message.success("Encuesta eliminada");
          //   })
          //   .catch(() => {
          //     this.$message.info("Eliminacion cancelada");
          //   });
          break;

        default:
          break;
      }
    }
  }
};
</script>

<style>
.center-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 5vh;
}
.centered-tag {
  font-size: 1em; /* Ajusta el tamaño del texto según tus necesidades */
  /* Estilos adicionales del tag si es necesario */
}
.custom-form .el-form-item__label {
  display: none; /* Oculta la etiqueta predeterminada */
}

.custom-form .custom-label {
  display: block;
  font-weight: bold; /* Otras propiedades de estilo según tus preferencias */
  margin-bottom: 8px; /* Ajusta el margen inferior según tus necesidades */
}

.el-form-item__label {
  font-weight: bold; /* Otras propiedades de estilo según tus preferencias */
}
</style>
